import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/site/Hero";
import Affiliations from "@/components/site/Affiliations";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Features from "@/components/site/Features";
import SpecialOffer from "@/components/site/SpecialOffer";
import Testimonials from "@/components/site/Testimonials";
import Gallery from "@/components/site/Gallery";
import FinalCTA from "@/components/site/FinalCTA";
import Seo from "@/components/site/Seo";
import {
  dentalClinicSchema,
  websiteSchema,
  doctorsSchema,
  breadcrumbSchema,
} from "@/lib/seo";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 120);
      }
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <>
      <Seo
        title="Dentists in Leesburg, VA"
        description="Family, cosmetic and implant dentistry in Leesburg, VA. Bilingual team led by Drs. Yopa, Ide Noumy & Ebrahimi. Book your visit — call 571-510-3034."
        path="/"
        jsonLd={[
          dentalClinicSchema(),
          websiteSchema(),
          ...doctorsSchema(),
          breadcrumbSchema([{ name: "Home", path: "/" }]),
        ]}
      />
      <Hero />
      <Affiliations />
      <Services />
      <About />
      <Features />
      <SpecialOffer />
      <Testimonials />
      <Gallery />
      <FinalCTA />
    </>
  );
}
